import { z } from "zod";
import { RequestTypeDtoSchema } from "./RequestTypeDto";
import { RequestTagDataSchema } from "./RequestTagData";

export const RequestTypeWithTagsDtoSchema = z.object({
    requestType: RequestTypeDtoSchema.nullish(),
    requestTag: RequestTagDataSchema.nullish(),
});

export type RequestTypeWithTagsDto = z.infer<typeof RequestTypeWithTagsDtoSchema>;